import React, { memo, forwardRef } from "react";
const SvgCapitalPsi = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.624 24.136a1 1 0 01-1-1v-3.488c-1.088-.048-2.048-.232-2.88-.552-.832-.32-1.528-.776-2.088-1.368-.544-.592-.96-1.328-1.248-2.208C8.136 14.624 8 13.584 8 12.4V8a1 1 0 011-1h.208a1 1 0 011 1v4.424c0 1.376.184 2.456.552 3.24.368.784.88 1.336 1.536 1.656.672.32 1.448.48 2.328.48V8a1 1 0 011-1h.112a1 1 0 011 1v9.8c.88 0 1.648-.16 2.304-.48.672-.32 1.192-.872 1.56-1.656.368-.784.552-1.864.552-3.24V8a1 1 0 011-1h.208a1 1 0 011 1v4.4c0 1.584-.248 2.904-.744 3.96a5.184 5.184 0 01-2.232 2.376c-.976.528-2.192.832-3.648.912v3.488a1 1 0 01-1 1h-.112z"
      />
    </svg>
  );
});
SvgCapitalPsi.displayName = "SvgCapitalPsi";
const MemoForwardRef = memo(SvgCapitalPsi);
export default MemoForwardRef;
